import React from 'react';

const DropdownTrigger = ({ children }) => (
  <div style={{ position: 'relative', zIndex: 2 }}>{children}</div>
);

DropdownTrigger.displayName = 'DropdownTrigger';

export default DropdownTrigger;
